﻿import getResource from '../../core/resources';
import SvgManager from '../../core/SvgManager';
import { getFormMetadata } from './formMetadata';
import { getFormValues } from './formValues';

const images = {
	folder: '../images/Folder.svg',
	itemType: '../images/ItemType.svg'
};
SvgManager.enqueue(Object.values(images));

const generateFormData = (stateData, state, form) => {
	const { order } = form;
	const metadata = getFormMetadata(stateData, state, order);
	const data = getFormValues(stateData, state, order);

	return { ...form, data, metadata };
};

const getCategoryFormData = () => {
	const image = images.folder;
	const label = getResource('toc_editor.category');
	const order = ['label'];

	return {
		image,
		label,
		order
	};
};

const getItemTypeFormData = () => {
	const image = images.itemType;
	const label = getResource('toc_editor.itemtype');
	const order = ['itemType', 'image', 'label', 'access'];

	return {
		image,
		label,
		order
	};
};

export const getFormData = (data, state) => {
	const { selectedId } = state;
	const relshipItem = data.get(selectedId);
	if (!relshipItem) {
		return null;
	}

	let formData = null;
	const relatedItem = data.get(relshipItem.related_id);
	const { '@odata.type': type, additional_data: additionalData } = relatedItem;
	if (type === '#CommandBarMenu') {
		formData = getCategoryFormData();
	} else if (additionalData?.itemTypeId) {
		formData = getItemTypeFormData();
	}

	if (formData) {
		return generateFormData(data, state, formData);
	}

	return formData;
};

const getItemChange = (propName, newValue) => {
	const { itemId, label } = newValue;
	switch (propName) {
		case 'access':
			return {
				'role@aras.id': itemId,
				'role@aras.keyed_name': label
			};
		case 'itemType':
			return {
				additional_data: {
					itemTypeId: itemId
				}
			};
		default:
			return null;
	}
};

export const getFormChange = (form, state, detail) => {
	const { newValue, propName } = detail;
	const type = form.metadata[propName]?.type;
	switch (type) {
		case 'multiLingual': {
			const { defaultLanguageCode } = state;
			return Object.entries(newValue).reduce((change, [code, value]) => {
				if (code === defaultLanguageCode) {
					change[propName] = value;
				}
				change[`${propName}@aras.lang.${code}`] = value;
				return change;
			}, {});
		}
		case 'item': {
			return getItemChange(propName, newValue);
		}
		case 'image': {
			return { image: newValue };
		}
		default:
			return null;
	}
};
